import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface LogoMarkProps {
    className?: string
}

interface LogoProps {
    className?: string
    tone?: 'dark' | 'light'
}

export const LogoMark: FC<LogoMarkProps> = ({ className }): ReactNode => {
    return (
        <svg viewBox='0 0 40 40' aria-hidden='true' className={cn('size-9 shrink-0', className)}>
            <g stroke='var(--coral, #ea6f4b)' strokeWidth='2.4' strokeLinecap='round'>
                <path d='M20 8.2v3' />
                <path d='M11.8 11.6l2.1 2.1' />
                <path d='M28.2 11.6l-2.1 2.1' />
                <path d='M8.4 19.6h3' />
                <path d='M28.6 19.6h3' />
            </g>

            <circle cx='20' cy='20.2' r='5.6' fill='var(--coral, #ea6f4b)' />
            <path d='M5 23.2c5.6-1.4 10.4-0.8 14.3 1.8v10.4c-3.9-2.6-8.7-3.1-14.3-1.8z' fill='currentColor' />
            <path d='M35 23.2c-5.6-1.4-10.4-0.8-14.3 1.8v10.4c3.9-2.6 8.7-3.1 14.3-1.8z' fill='currentColor' />
        </svg>
    )
}

export const Logo: FC<LogoProps> = ({ className, tone = 'dark' }): ReactNode => {
    return (
        <span className={cn('inline-flex items-center gap-2.5', tone === 'dark' ? 'text-ink' : 'text-paper', className)}>
            <LogoMark />

            <span className='font-heading font-soft text-[1.45rem] leading-none font-semibold tracking-[-0.01em]'>
                Leesritme
            </span>
        </span>
    )
}
